import styled from 'styled-components';

export const StyledNotificationsList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style: none;
`;
